import { Injectable } from '@angular/core';
import { LogEntry } from '@timechef/core/logging/log-entry';
import { Sink } from '@timechef/core/logging/sinks/sink';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LogLevel } from 'src/environments/environment-config';

@Injectable({ providedIn: 'root' })
export class ConsoleSink extends Sink {
  constructor() {
    super(environment.logging['console']);
  }

  log(entry: LogEntry): Observable<void> {
    switch (entry.logLevel) {
      case LogLevel.Debug:
        console.debug(entry.buildLogString());
        break;
      case LogLevel.Info:
        console.info(entry.buildLogString());
        break;
      case LogLevel.Warn:
        console.warn(entry.buildLogString());
        break;
      case LogLevel.Error:
        console.error(entry.buildLogString());
        break;
      case LogLevel.Fatal:
        console.error(entry.buildLogString());
        break;
      default:
        console.log(entry.buildLogString());
    }
    return of();
  }
}
